(function () {
    'use strict';

    const REFINER_SCRIPT_URL = 'https://js.refiner.io/v001/client.js';
    const REFINER_PROJECT_ID_TEST = 'aa74f830-1196-11f1-91c0-eb9859d22b95';
    const REFINER_PROJECT_ID_LIVE = '785b0690-9e9c-11f0-803c-1949848cc509';

    angular.module('itero').run(['$rootScope', '$window', '$http', 'PublicSettings', function ($rootScope, $window, $http, PublicSettings) {
        if (!PublicSettings.RefinerEnabled) {
            return;
        }

        const host = ($window.location && $window.location.hostname || '').toLowerCase();
        const isTestLike = host.indexOf('test') !== -1 || host.indexOf('staging') !== -1 || host.indexOf('qa') !== -1 || host.indexOf('localhost') !== -1;
        const projectId = isTestLike ? REFINER_PROJECT_ID_TEST : REFINER_PROJECT_ID_LIVE;
        let hasIdentifiedUser = false;
        // Skip starting init again while we're still waiting for user/entity and traits (avoids double identify on login)
        let isInitializing = false;

        function ensureQueue() {
            if (!$window._refinerQueue) {
                $window._refinerQueue = [];
            }
            if (typeof $window._refiner !== 'function') {
                $window._refiner = function () {
                    $window._refinerQueue.push(arguments);
                };
            }
        }

        function loadSdk() {
            if (document.querySelector('script[data-refiner-client="true"]')) {
                return;
            }
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.src = REFINER_SCRIPT_URL;
            script.setAttribute('data-refiner-client', 'true');
            document.getElementsByTagName('script')[0].parentNode.insertBefore(script, document.getElementsByTagName('script')[0]);
        }

        function fetchTraits() {
            return $http.get('/api/v1/refiner/traits', { cache: false })
                .then(function (res) { return res && res.data ? res.data : null; })
                .catch(function () { return null; });
        }

        function identifyUser(traits) {
            if (!traits || !traits.Contact || !traits.Contact.EmailAddress) {
                return false;
            }
            const contact = traits.Contact;
            const account = traits.Account || {};
            const payload = {
                id: contact.EmailAddress,
                UserId: contact.UserId,
                FirstName: contact.FirstName,
                LastName: contact.LastName,
                EmailAddress: contact.EmailAddress,
                Language: contact.Language,
                RegistrationDate: contact.RegistrationDate,
                LastLogin: contact.LastLogin,
                UserType: contact.UserType,
                Permissions: contact.Permissions,
                RootLegalEntityId: contact.RootLegalEntityId,
                account: {
                    CompanyName: account.CompanyName,
                    CompanyEmail: account.CompanyEmail,
                    Created: account.Created,
                    Status: account.Status,
                    ContractId: account.ContractId,
                    ExternalId: account.ExternalId
                }
            };
            $window._refiner('setLocale', payload.Language || 'en');
            $window._refiner('identifyUser', payload);
            $window._refiner('startSession');
            return true;
        }

        function shutdown() {
            try {
                if (typeof $window._refiner === 'function') {
                    $window._refiner('resetUser');
                    $window._refiner('stopPinging');
                }
            } catch (e) { console.warn('[Refiner] shutdown error', e); }
            hasIdentifiedUser = false;
        }

        function trackPageEvents() {
            $window._refiner('trackEvent', 'page_view');
        }

        function registerCallbacks() {
            try {
                $window._refiner('onError', function (args) {
                    console.warn('[Refiner]', args);
                });
            } catch (e) { console.warn('[Refiner] registerCallbacks error', e); }
        }

        function init() {
            if (isInitializing) return;
            isInitializing = true;

            ensureQueue();
            $window._refiner('setProject', projectId);
            loadSdk();
            registerCallbacks();

            const unwatch = $rootScope.$watch(function () {
                return !!($rootScope.user && $rootScope.chosenEntity);
            }, function (ready) {
                if (!ready) return;
                unwatch();
                fetchTraits().then(function (traits) {
                    if (identifyUser(traits)) {
                        hasIdentifiedUser = true;
                        trackPageEvents();
                    }
                }).finally(function () {
                    isInitializing = false;
                });
            });
        }

        init();

        $rootScope.$on('$routeChangeSuccess', function () {
            if (typeof $window._refiner !== 'function' || !hasIdentifiedUser) return;
            trackPageEvents();
        });

        // Logout: clear Refiner; login: re-init and identify when user/entity ready
        $rootScope.$watch(function () { return $rootScope.getStoredAccessToken(); }, function (newVal, oldVal) {
            if (oldVal && !newVal) {
                shutdown();
            } else if (!oldVal && newVal) {
                init();
            }
        });
    }]);
})();
